import { useTranslation } from 'react-i18next';

/** Single source of truth for supported RTL languages on the client */
export const RTL_LANGUAGES = ['he', 'ar'];

/**
 * Hook to detect RTL (right-to-left) text direction.
 * Checks multiple sources for reliability:
 * 1. Document dir attribute (most reliable, set via HTML tag)
 * 2. i18n language code (checks if language is in RTL list)
 * 3. i18n.dir() function
 */
export const useIsRtl = (): boolean => {
  const { i18n } = useTranslation();

  if (
    typeof document !== 'undefined' &&
    document.documentElement?.dir === 'rtl'
  ) {
    return true;
  }

  const language = i18n?.language;
  if (language) {
    // Handle both 'he/ar' and 'he_IL/ar_SA' formats
    const langCode = language.split(/[-_]/)[0].toLowerCase();
    if (RTL_LANGUAGES.includes(langCode)) {
      return true;
    }
  }

  return i18n?.dir?.() === 'rtl';
};
